import { useAuthState } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import {
  useAssignedDomains,
  useEffectiveRoles,
  usePermissionMutations
} from '@percent/admin-dashboard/app/accounts/hooks'
import { AccountPermissionsDrawer } from '@percent/domain/iam'

export type AccountPermissionsContainerProps = {
  isOpen: boolean
  account: {
    accountId: string
    accountName: string
  } | null
  onClose: () => void
}

export function AccountPermissionsContainer({ isOpen, account, onClose }: AccountPermissionsContainerProps) {
  const { iamService } = useServices()
  const { user } = useAuthState()

  const isDisabled = user?.id === account?.accountId

  const { assignedDomains, isLoading, markChanged, refresh } = useAssignedDomains('accounts', account?.accountId)

  const {
    effectiveDomains,
    getGroupHref,
    refresh: refreshEffectiveRoles
  } = useEffectiveRoles('accounts', account?.accountId)

  const { assignRole, unassignRole } = usePermissionMutations(
    iamService.assignAccountRole,
    iamService.unassignAccountRole,
    refresh,
    () => {
      markChanged()
      refreshEffectiveRoles()
    }
  )

  const handleAssignAccountRole = async (memberId: string, roleId: string, domainId: string) =>
    assignRole({ memberId, role: roleId, domainId })

  const handleUnassignAccountRole = async (memberId: string, roleId: string, domainId: string) =>
    unassignRole({ memberId, role: roleId, domainId })

  return (
    <AccountPermissionsDrawer
      isOpen={isOpen}
      onClose={onClose}
      account={account}
      isLoading={isLoading}
      isDisabled={isDisabled}
      assignedDomains={assignedDomains ?? []}
      effectiveDomains={effectiveDomains}
      getGroupHref={getGroupHref}
      assignAccountRole={handleAssignAccountRole}
      unassignAccountRole={handleUnassignAccountRole}
    />
  )
}
